import { lazy } from "react";
import { RouterItemType } from "@/app/index";
import { serviceBusinessUnitsApi } from "@/services/business-units";
import { serviceServicesApi } from "@/services/services";
import { BusinessUnitItemType } from "@/schemas/business-unit/business-unit-item";
import { ServiceProductItemType } from "@/schemas/services/service-product-item";

const LayoutPageRequestCreate = lazy(() => import("./layout/index"));

export const loaderDataRequestCreate = async () => {
  try {
    const [businessUnitsResponse, productsResponse, servicesResponse] =
      await Promise.all([
        serviceBusinessUnitsApi.fetchBusinessUnits(0, 100, ""),
        serviceServicesApi.fetchServiceProducts(),
        serviceServicesApi.fetchServiceTypes(),
      ]);

    const dataLoader = {
      businessUnits: businessUnitsResponse.Results || [],
      products: productsResponse || [],
      services: servicesResponse || [],
    };

    return dataLoader;
  } catch (err) {
    console.log(err);
    throw new Error("DATA_NOT_FOUND");
  }
};

export const routerPageRequestCreate: RouterItemType = {
  path: "/service/requests/create",
  authorize: true,
  element: <LayoutPageRequestCreate />,
  loader: loaderDataRequestCreate,
};

export type RouterDataType = {
  businessUnits: BusinessUnitItemType[];
  products: ServiceProductItemType[];
  services: { Id: string; Name: string }[];
};
